import moment from "moment";
import { InputText } from "primereact/inputtext";
import { SeverityType } from "./interfaces";

export const formatTime = (date: Date | null) =>
  date ? moment(date).format("HH:mm") : "";

export const formatDateTime = function (date: any) {
  return date ? moment.utc(date).format("DD MMM YYYY") : null;
};

export const formatYear = function (date: any) {
    return date ? moment.utc(date + 1).format('YYYY') : null;
};

// global datatable name filter
export const globalNameFilterTemplate = (options: any) => {
  const filterFieldPlaceholder = options.field
    .split("_")
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return (
    <InputText
      value={options.value || ""}
      onChange={(e) => options.filterCallback(e.target.value)}
      placeholder={"Search by " + filterFieldPlaceholder}
      className="p-column-filter"
    />
  );
};

// Amount Formate
export const amountFormate = (amt: any) => {
  let amount: any = "";
  amt = Number(amt);
  amount = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(amt);

  return amount;
};

// get status SeverityType global case
export const getBookingStatusSeverity = (status: string | undefined): SeverityType => {
  switch (status?.toLowerCase()) {
    case "pending":
      return "warning";
    case "cancelled":
      return "danger";
    case "completed":
      return "success";
    case "confirmed":
      return "info";
    case "pre-confirmed":
      return "info";
    default:
      return undefined;
  }
};
